import React from 'react';

const About = () => {
  const stats = [
    { value: '~10', label: 'Years across backend + SDET' },
    { value: '5,000+', label: 'Test cases shipped' },
    { value: '6+', label: 'Frameworks built from scratch' },
    { value: 'AWS', label: 'Solutions Architect (Associate)' },
  ];

  return (
    <section name='about' className='w-full py-24 sm:py-32 bg-bg-alt'>
      <div className='container-narrow'>
        <p className='section-eyebrow'>01. About me</p>
        <h2 className='section-title'>Who I am</h2>
        <div className='w-12 h-1 bg-accent rounded-full mb-12' />

        <div className='grid lg:grid-cols-3 gap-10'>
          <div className='lg:col-span-2 space-y-5 text-zinc-300 leading-relaxed'>
            <p>
              I'm a software engineer with nearly a decade of experience across both{' '}
              <span className='text-accent font-medium'>backend development</span> and{' '}
              <span className='text-accent font-medium'>test automation</span>. I sit
              comfortably between writing Java/Spring Boot services and building the
              automated test frameworks that prove they work in production.
            </p>
            <p>
              On the backend, I work day-to-day with{' '}
              <span className='text-accent font-medium'>Java</span>,{' '}
              <span className='text-accent font-medium'>Spring Boot</span>, and{' '}
              <span className='text-accent font-medium'>Quarkus</span> — designing REST
              APIs, reading service code across the squad, and reviewing pull requests for
              correctness and design. AWS Certified Solutions Architect (Associate) and
              Oracle Certified Professional in Java SE 8.
            </p>
            <p>
              On the test side, I specialize in the{' '}
              <span className='text-accent font-medium'>Karate Framework</span> for API
              coverage, <span className='text-accent font-medium'>Playwright</span> for
              end-to-end UI testing, <span className='text-accent font-medium'>k6</span>{' '}
              for performance, and <span className='text-accent font-medium'>Pact</span>{' '}
              for contract testing. I've built test frameworks from scratch — standalone
              Karate projects, Spring-integrated suites, and shared utility libraries —
              with CI/CD on <span className='text-accent font-medium'>Jenkins</span>,{' '}
              <span className='text-accent font-medium'>GitHub Actions</span>, and{' '}
              <span className='text-accent font-medium'>Concourse</span>, deployed on{' '}
              <span className='text-accent font-medium'>Docker</span> and{' '}
              <span className='text-accent font-medium'>Kubernetes</span>.
            </p>
            <p>
              I treat testing as engineering — built alongside the code, not after it.
              Open to <span className='text-accent font-medium'>Senior Software Engineer</span>,{' '}
              <span className='text-accent font-medium'>Backend Engineer</span>, and{' '}
              <span className='text-accent font-medium'>SDET</span> roles where I can pair
              hands-on Java with deep test automation expertise.
            </p>
          </div>

          <div className='space-y-3'>
            {stats.map((s) => (
              <div
                key={s.label}
                className='rounded-xl border border-zinc-800 bg-bg-elev p-4 hover:border-accent/40 transition-colors'
              >
                <div className='font-mono text-2xl font-bold text-accent leading-none'>{s.value}</div>
                <div className='text-zinc-400 text-sm mt-2 leading-snug'>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
